import { render } from "./LeaveTypesManagement.vue?vue&type=template&id=c488bcac&scoped=true"
import script from "./LeaveTypesManagement.vue?vue&type=script&lang=js"
export * from "./LeaveTypesManagement.vue?vue&type=script&lang=js"

import "./LeaveTypesManagement.vue?vue&type=style&index=0&id=c488bcac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c488bcac"]])

export default __exports__